import { useState } from "react";
import { api, getApiError } from "@/lib/api";
import { toLocalInputValue } from "@/lib/format";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { toast } from "sonner";

export const EditTxnDateDialog = ({ customerId, txn, onClose, onSaved }) => {
  const [value, setValue] = useState(() => toLocalInputValue(txn?.created_at));
  const [saving, setSaving] = useState(false);

  const save = async () => {
    if (!value) return toast.error("Pick a date and time");
    setSaving(true);
    try {
      await api.patch(`/admin/customers/${customerId}/transactions/${txn.id}`, {
        created_at: new Date(value).toISOString(),
      });
      toast.success("Transaction date updated. Balances recalculated.");
      onSaved();
    } catch (e) {
      toast.error(getApiError(e));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={!!txn} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="edit-txn-date-dialog">
        <DialogHeader>
          <DialogTitle>Edit transaction date</DialogTitle>
          <DialogDescription>
            Running balances will be recalculated in date order. Current balance stays the same.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-2">
          <Label className="label-overline">Date &amp; time</Label>
          <Input
            type="datetime-local"
            data-testid="edit-txn-date-input"
            value={value}
            max={toLocalInputValue()}
            onChange={(e) => setValue(e.target.value)}
            className="font-mono-num"
          />
        </div>
        <DialogFooter>
          <Button variant="outline" data-testid="edit-txn-date-cancel" onClick={onClose}>
            Cancel
          </Button>
          <Button
            data-testid="edit-txn-date-save"
            onClick={save}
            disabled={saving}
            className="bg-slate-900 hover:bg-slate-800"
          >
            {saving ? "Saving…" : "Save"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
